import { styled } from 'baseui'

export const StyledPaginatorWrapper = styled('div', {
  margin: '1.25rem 0',
  display: 'flex',
  justifyContent: 'center',
  flexWrap: 'wrap',
  background: '#fff',
  borderRadius: '0.5rem',
  padding: '0.5rem 1rem',
  boxShadow: '0 0.0625rem 0.25rem rgba(30, 30, 30, 0.07)'
});

export const StyledPageButton = styled('button', ({ $active }) => ({
  margin: '0 0.1875rem',
  fontWeight: $active ? 'bold' : 'normal',
  background: $active ? '#ffe066' : '#fff',
  border: '1px solid #ddd',
  borderRadius: '0.1875rem',
  padding: '0.1875rem 0.625rem',
  minWidth: '1.875rem',
  cursor: $active ? 'default' : 'pointer',
  transition: 'background 0.13s',
  opacity: 1,
  ':hover': {
    background: $active ? '#ffe066' : '#f6f6f6'
  },
  ':disabled': {
    opacity: 0.6,
    cursor: 'default'
  }
}));

export const StyledDots = styled('span', {
  margin: '0 0.25rem',
  userSelect: 'none',
  color: '#888',
  fontSize: '1.2em'
});
